import script from "./ESportsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ESportsContainer.vue?vue&type=script&setup=true&lang=js"

import "./ESportsContainer.vue?vue&type=style&index=0&id=5422df71&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5422df71"]])

export default __exports__